/**
 * @generated SignedSource<<a40debf53643c179686528b35a04c818>>
 * @relayHash 44c630119a59e5014273a5046205cacd
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-trade/576.0.0-2026-09-10T13:50:28.261Z/useLoadPhotoLikesQuery

import { ConcreteRequest } from 'relay-runtime';
export type useLoadPhotoLikesQuery$variables = {
  hasUserId: boolean;
  shouldLoadPhotoLikes: boolean;
  urlLabels: ReadonlyArray<string>;
  userId?: string | null;
};
export type useLoadPhotoLikesQuery$data = {
  readonly viewer: {
    readonly tradePhotosQuery?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly photo: {
            readonly photoLike: {
              readonly photoLikeId?: string | null;
              readonly totalPhotoLikes: number | null;
            } | null;
            readonly serviceId: string | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
  };
};
export type useLoadPhotoLikesQuery = {
  response: useLoadPhotoLikesQuery$data;
  variables: useLoadPhotoLikesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasUserId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldLoadPhotoLikes"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "urlLabels"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "urlLabels",
    "variableName": "urlLabels"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "PhotoLike",
  "kind": "LinkedField",
  "name": "photoLike",
  "plural": false,
  "selections": [
    {
      "condition": "hasUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "kind": "ScalarField",
          "name": "photoLikeId",
          "storageKey": null
        }
      ]
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalPhotoLikes",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useLoadPhotoLikesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "shouldLoadPhotoLikes",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v4/*:: as any*/),
                "concreteType": "TradePhotoQueryConnection",
                "kind": "LinkedField",
                "name": "tradePhotosQuery",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TradePhotoQueryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradePhotosQueryOutput",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TradePhoto",
                            "kind": "LinkedField",
                            "name": "photo",
                            "plural": false,
                            "selections": [
                              (v5/*:: as any*/),
                              (v6/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "useLoadPhotoLikesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "shouldLoadPhotoLikes",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v4/*:: as any*/),
                "concreteType": "TradePhotoQueryConnection",
                "kind": "LinkedField",
                "name": "tradePhotosQuery",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TradePhotoQueryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradePhotosQueryOutput",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TradePhoto",
                            "kind": "LinkedField",
                            "name": "photo",
                            "plural": false,
                            "selections": [
                              (v5/*:: as any*/),
                              (v6/*:: as any*/),
                              (v7/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          (v7/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-trade/576.0.0-2026-09-10T13:50:28.261Z/useLoadPhotoLikesQuery",
    "metadata": {},
    "name": "useLoadPhotoLikesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "cd234904fed4ecd4a0687c0641398d88";

export default node;
